export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image — Real Warehouse Photo */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/9f45cb21-4b77-4979-b082-2610d4bf0c89/aa5cc019-b06f-444e-919b-37cb544c4cc9_20260407_142350.jpg?v=dc89050f8bbee3caa02b21282e8915cd"
          alt="Hangzhou YAXIN warehouse shelves — Shell HK distributor auto parts storage Guangzhou Chirun logistics hub"
          className="w-full h-full object-cover object-center"
        />
        {/* Strong dark overlay for text contrast */}
        <div className="absolute inset-0 bg-[#0A0F1A]/45"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0F1A]/85 via-[#0A0F1A]/40 to-[#0A0F1A]/10"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 pt-24 pb-16">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 border border-[#C9A84C]/50 bg-[#C9A84C]/10 px-4 py-2 rounded-sm mb-8">
            <div className="w-2 h-2 bg-[#C9A84C] rounded-full animate-pulse"></div>
            <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.25em] uppercase">
              Белая таможня · ГТД/НДС · Честный ЗНАК · EAC
            </span>
          </div>

          {/* H1 */}
          <h1 className="text-white leading-none mb-6" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(52px, 7vw, 96px)", letterSpacing: "0.02em" }}>
            YAXIN LIANPEI<br />
            <span className="text-[#C9A84C]">30 ЛЕТ</span> ЭКСПОРТА<br />
            АВТОЗАПЧАСТЕЙ
          </h1>

          {/* Subtitle */}
          <p className="text-gray-300 text-lg md:text-xl font-light leading-relaxed mb-4 max-w-2xl">
            MERCEDES-BENZ · BMW · VAG Group · Jaguar Land Rover · Shell Oils из Гонконга
          </p>
          <h2 className="text-gray-400 text-base leading-relaxed mb-10 max-w-xl font-normal">
            YAXIN / CHIRUN — прямой оператор автозапчастей и масел Shell из КНР. 100% «белая» таможня (ГТД, НДС), прямые контракты и сертификация EAC.
          </h2>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-3 bg-[#C9A84C] hover:bg-[#b8943d] text-[#0A0F1A] font-bold text-base px-8 py-4 rounded-sm tracking-wide uppercase transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-list-3-line text-lg"></i>
              Запросить B2B прайс-лист
            </a>
            <a
              href="#matrix"
              className="inline-flex items-center justify-center gap-3 border border-white/30 hover:border-[#C9A84C] text-white hover:text-[#C9A84C] font-semibold text-base px-8 py-4 rounded-sm tracking-wide uppercase transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-table-line text-lg"></i>
              Матрица ТО и ремонта
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap gap-4 mt-12 pt-10 border-t border-white/10">
            {[
              { icon: "ri-shield-check-line", label: "EAC Сертификация", sub: "Официальный заявитель" },
              { icon: "ri-government-line", label: "Белая таможня", sub: "ГТД/НДС · 100% легально" },
              { icon: "ri-qr-code-line", label: "Честный ЗНАК", sub: "Нанесение в Гуанчжоу" },
              { icon: "ri-global-line", label: "3 валюты", sub: "CNY · USD · RUB" },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center border border-[#C9A84C]/40 rounded-sm">
                  <i className={`${item.icon} text-[#C9A84C] text-lg`}></i>
                </div>
                <div>
                  <div className="text-white text-sm font-semibold">{item.label}</div>
                  <div className="text-gray-400 text-xs">{item.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-gray-500 text-xs tracking-widest uppercase">Прокрутить</span>
        <i className="ri-arrow-down-line text-[#C9A84C] text-xl"></i>
      </div>
    </section>
  );
}
